import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5 py-24"
      data-testid="not-found-page"
    >
      <SEO title="Pagina non trovata" noindex suppressCanonical />
      <Helmet>
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <div className="font-serif text-7xl sm:text-8xl font-extrabold text-primary/90 mb-4">404</div>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold mb-3">Pagina non trovata</h1>
      <p className="text-muted-foreground max-w-md mb-8 leading-relaxed">
        La pagina che cerchi non esiste oppure è stata spostata.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Button asChild className="rounded-sm h-11 px-6" data-testid="notfound-home-btn">
          <Link to="/">Torna alla home</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-sm h-11 px-6" data-testid="notfound-archive-btn">
          <Link to="/archivio">Vai all'archivio</Link>
        </Button>
      </div>
    </div>
  );
}
